import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-[#050505] border-y border-white/5" data-id="element-49">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-51">
          <div className="w-32 h-32 rounded-full bg-brand-pink/10 border-2 border-brand-pink flex items-center justify-center mb-8 relative" data-id="element-52">
            <div className="absolute inset-0 bg-brand-pink/20 blur-xl rounded-full" data-id="element-53"></div>
            <ShieldCheck className="w-16 h-16 text-brand-pink relative z-10" data-id="element-54" />
            <div className="absolute -bottom-3 bg-brand-black border border-brand-pink text-brand-pink text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-55">
              7 Días
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-56">
            🛡️ Garantía de Hierro
          </h2>

          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-57">
            Accedé al material, descargalo y probalo. Si en 7 días sentís que
            esto no es para vos, te devolvemos cada centavo. Sin vueltas.{' '}
            <span className="text-brand-pink font-semibold" data-id="element-58">
              El riesgo es nuestro.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}